/* Created by:Upendram Reddy Tanuja
Created on: 19-Sep-2019 11:30 AM
Purpose: To  save resume*/
import { Component, OnInit, Inject, Renderer2, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ResumeBankService } from '../../services/resume-referral/resume-referral.service';
import { ResumeReferralCopyService } from '../../services/resume-referral-copy/resume-referral-copy.service';
import { StandardFile } from '../../classes/shared/file/file';
import { ResumeDetails } from '../../classes/resume/resume-details';
import { SkillDetails } from '../../classes/resume/skill-details';
import { Options, LabelType } from 'ng5-slider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SessionService } from 'src/app/services/session/session.service';
import { MessageService } from 'src/app/services/message/message.service';
import { type } from '@amcharts/amcharts4/core';
import { LoaderService } from '../loader/services/loader/loader.service';
import { IfStmt } from '@angular/compiler';
@Component({
  selector: 'app-resume-referral-copy',
  templateUrl: './resume-referral-copy.component.html',
  styleUrls: ['./resume-referral-copy.component.scss'],
  providers: [ResumeBankService],
})
export class ResumeReferralCopyComponent implements OnInit {
  resume_referral: UntypedFormGroup;
  master = [];
  file_name;
  search: string;
  flag = 1;
  resume_details = new ResumeDetails();
  public loading = 0;
  @Input() requirement_id;
  @Input() referrer_id;
  @Input() user_id;
  search_loc: string;
  skill_rating: any = [];
  skill_rating_copy: any = [];
  skill_details = new SkillDetails();
  options: Options;
  skill_form: UntypedFormGroup;
  level_type: any = [];
  skill_match = false;
  terms_conditions = false;
  description;
  value;
  resume_ref_display;
  length_file;
  files;
  init() {
    this.file_name = '';
    this.skill_details = new SkillDetails();
    this.resume_details = new ResumeDetails();
    this.skill_form = new UntypedFormGroup(
      {
        skill_code: new UntypedFormControl(0),
        skill_rating: new UntypedFormControl(0)
      });
    this.resume_referral = new UntypedFormGroup(
      {
        first_name: new UntypedFormControl('', Validators.required),
        last_name: new UntypedFormControl(''),
        mobile_no: new UntypedFormControl('', [Validators.required, Validators.min(1000000000), Validators.max(9999999999)]),
        mobile_no_cc: new UntypedFormControl(0, Validators.required),
        email_id: new UntypedFormControl('', [Validators.required, Validators.pattern(/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-z]{2,4}|[0-9]{1,3})(\]?)$/)]),
        currency_code: new UntypedFormControl(0),
        duration_code: new UntypedFormControl(0),
        scale_code: new UntypedFormControl(0),
        education_code: new UntypedFormControl(null),
        skill_code: new UntypedFormControl([]),
        current_employee: new UntypedFormControl(''),
        current_designation: new UntypedFormControl(0),
        experience: new UntypedFormControl(null),
        amount: new UntypedFormControl(''),
        current_location: new UntypedFormControl(0),
        notice_period: new UntypedFormControl(null),
        pin_code: new UntypedFormControl(null),
        relevant_experience: new UntypedFormControl(null),
      }
    );
  }

  constructor(
    public dialogRef: MatDialogRef<ResumeReferralCopyComponent>,
    private _renderer2: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data,
    private resume_serivce: ResumeReferralCopyService,
    private _snackBar: MatSnackBar,
    private message_service: MessageService,
    private loader: LoaderService
  ) {

  }

  ngOnInit() {
    this.init();

    if (this.data && this.data.profile) {
      this.resume_details.setLinkedInData(this.data.profile);
      this.resume_referral.controls.first_name.setValue(this.resume_details.first_name);
      this.resume_referral.controls.last_name.setValue(this.resume_details.last_name);
      this.resume_referral.controls.email_id.setValue(this.resume_details.email_id);
    }
    this.resume_serivce.getResumeDetails(this.requirement_id, this.referrer_id).subscribe(res => {
      if (res['data']) {
        this.resume_ref_display = true;
        if (res['data'].termsandconditions) {
          this.description = res['data'].termsandconditions.description;
          this.value = res['data'].termsandconditions.value;
        }
        if (res['data'].masters) {
          if (res['data'].masters.currency) {
            this.master['currency'] = res['data'].masters.currency || [];
          }
          if (res['data'].masters.duration) {
            this.master['duration'] = res['data'].masters.duration || [];
          }
          if (res['data'].masters.education) {
            this.master['education'] = res['data'].masters.education || [];
          }
          if (res['data'].masters.isd) {
            this.master['isd'] = res['data'].masters.isd || [];
            if (this.master['isd'].length == 1) {
              this.selected_obj(this.master['isd'][0]);
              //this.resume_referral.controls.mobile_no_cc.setValue(1000);
            }
          }
          if (res['data'].masters.scale) {
            this.master['scale'] = res['data'].masters.scale || [];
          }
          if (res['data'].masters.skills) {
            this.master['skills'] = res['data'].masters.skills || [];
          }
          if (res['data'].masters.specialization) {
            this.master['specialization'] = res['data'].masters.specialization || [];
          }
          if (res['data'].masters.designation) {
            this.master['designation'] = res['data'].masters.designation || [];
          }
          if (res['data'].masters.location) {
            this.master['location'] = res['data'].masters.location || [];
          }
          if (res['data'].masters.skill_match && res['data'].masters.skill_match.length) {
            this.skill_match = res['data'].masters.skill_match[0].is_enabled;
          }
          if (res['data'].masters.skill_rating && this.skill_match == true) {
            this.master['skill_rating'] = res['data'].masters.skill_rating || [];
            for (let i = 0; i < this.master['skill_rating'].length; i++) {
              let obj = {}
              obj["value"] = this.master['skill_rating'][i].skill_level_code;
              // obj["legend"] = this.master['skill_rating'][i].level_title;
              this.level_type.push(obj);
              obj = {};
            }
            this.options = {
              showTicksValues: true,
              stepsArray: this.level_type,
              translate: (value: number, label: LabelType): string => {
                //
                // for (let i = 0; i < this.master['skill_rating'].length; i++) {
                //   return this.master['skill_rating'][i].label_title;
                // }
                for (let i = 0; i < this.master['skill_rating'].length; i++) {
                  if (value == this.master['skill_rating'][i].skill_level_code) {
                    return this.master['skill_rating'][i].level_title;
                  }
                }
              }
            };
          }
        }
        if (res['data'].details) {

          this.resume_details.setData(res['data'].details);
          if (this.resume_details && this.resume_details.files && this.resume_details.files.attachment_id) {
            this.length_file = 1;
          }
          this.skill_rating_copy = this.resume_details.skill_rating;
          this.resume_referral.setValue(this.resume_details.getFormGroupData());

        }
      }
    },
      err => {

        if (this.message_service.storage === 401) {
          this._snackBar.open('Unauthorized');
          this.dialogRef.close(null);
        }
      })
  }
  public file_doc: any;
  base64;
  file_title;
  mime_type;
  saveFileResult(ev) {

    this.resume_details.files = (ev.files[0]);
    if (this.resume_details && (!this.resume_details.files || !this.resume_details.files['file_title'])) {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'red';
        }
      });

    }
    if (this.resume_details && this.resume_details.files && this.resume_details.files['status'] == 2) {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'red';
        }
      });
    }
    if (ev && ev.files && ev.files[0]) {
      this.base64 = (ev.files[0].content);
      this.file_title = (ev.files[0].file_title);
      this.mime_type = (ev.files[0].mime_type);
    }
    function dataURLtoFile(dataurl, filename) {
      if (dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      }
    }
    let file = dataURLtoFile(this.base64, this.file_title);
    this.file_doc = file;

    if (this.resume_details.files && this.resume_details.files['file_title'] && this.resume_details.files['status'] != 2) {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'rgb(138, 138, 138)';
        }
      });
      this.saveFile();
    }

  }
  saveFile() {
    let input = new FormData();
    if (this.file_doc && this.file_doc.name) {
      // Add your values in here
      input.append('attachment', this.file_doc, this.file_doc.name);
      this.loader.showLoader();
      this.resume_serivce.saveFile(input).subscribe(res => {

        this.resume_details.setFile(res['Document']);
        this.resume_referral.setValue(this.resume_details.getFormGroupData());
      })
    }
  }
  skill() {
    this.flag = 3;
    if (this.skill_match == true) {
      if (!(this.resume_details && this.resume_details.skill_rating && this.resume_details.skill_rating.length)) {
        //
        this.resume_details.skill_rating = [];
        for (let i = 0; i < this.master['skills'].length; i++) {
          let skill = this.resume_referral.controls.skill_code.value || [];
          if (skill && skill.length) {
            for (let j = 0; j < skill.length; j++) {
              if (this.master['skills'][i].skill_code == skill[j]) {
                this.skill_details.skill_code = this.master['skills'][i].skill_code;
                this.skill_details.skill_title = this.master['skills'][i].skill_title;
                this.skill_details.skill_rating = this.master['skill_rating'][0].skill_level_code;;
                this.resume_details.skill_rating.push(this.skill_details);
                this.skill_details = new SkillDetails();
              }
            }
          }
        }
        this.skill_rating_copy = this.resume_details.skill_rating;
      }
      else if (this.skill_rating_copy.length > 0) {
        this.resume_details.skill_rating = [];
        let skill = this.resume_referral.controls.skill_code.value || [];
        if (skill && skill.length) {
          for (let j = 0; j < skill.length; j++) {
            let count = 0;
            for (let i = 0; i < this.skill_rating_copy.length; i++) {

              if (skill[j] == this.skill_rating_copy[i].skill_code) {
                this.resume_details.skill_rating.push(this.skill_rating_copy[i]);
                count++;

              }

            }
            if (count == 0) {
              for (let k = 0; k < this.master['skills'].length; k++) {
                if (skill[j] == this.master['skills'][k].skill_code) {
                  this.skill_details.skill_code = this.master['skills'][k].skill_code;
                  this.skill_details.skill_title = this.master['skills'][k].skill_title;
                  this.skill_details.skill_rating = this.master['skill_rating'][0].skill_level_code;
                  this.resume_details.skill_rating.push(this.skill_details);
                  this.skill_details = new SkillDetails();
                }
              }
            }
          }
        }
      }
    }
  }
  skillRating() {
    this.flag = 2;
    this.skill_rating_copy = this.resume_details.skill_rating;
  }
  cancel() {
    this.dialogRef.close();
  }
  flagSecond() {
    let code = this.resume_details.files;
    if (this.resume_referral.valid && code && code['file_title'] && code['status'] == 1) {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'rgb(138, 138, 138)';
        }
      });
      this.flag = 2;
    }
    else if (!code || code['status'] == 2 || !code['file_title']) {
      this._snackBar.open('Please upload your resume');
      // document.getElementsByClassName('document').
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'red';
        }
      });
    }
    else {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'rgb(138, 138, 138)';
        }
      });
      this._snackBar.open('Please fill all the required fields')
    }
  }
  termsConditions() {
    this.terms_conditions = !this.terms_conditions;
  }

  save() {
    if (this.terms_conditions) {
      this.loading = 1;

      this.resume_details.requirement_id = this.requirement_id;
      this.resume_details.setFormGroupData(this.resume_referral.value);


      this.resume_serivce.saveResumeDetails(this.referrer_id, this.resume_details).subscribe(res => {

        if (res['data']) {
          this._snackBar.open(res['message']);
          this.dialogRef.close(res['data']);
        }
        else {
          this._snackBar.open(res['message']);
        }
        this.loading = 0;

      },
        err => {
          this.loading = 0;
          if (this.message_service.storage === 401) {
            this._snackBar.open('Unauthorized');
            this.dialogRef.close(null);
          }
        })
    }
    else if (!this.terms_conditions) {
      this._snackBar.open('Please accept the Terms and Conditions');
      // this.terms_conditions_req = "Please accept the Terms and Conditions";
    }
  }
  inputText(event: KeyboardEvent, max) {
    var input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;
    try {
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length === 0 && event.keyCode === 32 || input.value.length >= max) {
        return false;
      }
      if ((charCode > 64 && charCode < 91) || event.keyCode === 32) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (error) {

    }
  }
  inputTextMaxNull(event: KeyboardEvent) {
    var input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;
    try {
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length === 0 && event.keyCode === 32) {
        return false;
      }
      if ((charCode > 64 && charCode < 91) || event.keyCode === 32) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (error) {

    }
  }
  inputNumber(evt: KeyboardEvent) {
    let input = <HTMLInputElement>event.srcElement;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    try {
      if (charCode == 13) {
        return false;
      }
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length == 0) {
        if (charCode == 96 || charCode == 48) {
          return false
        }
        else if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          return true;
        }
        else {
          return false;
        }
      }
      else if (input.value.length >= this.mobile_number_length) {
        return false;
      }
      else if (input.value.length < this.mobile_number_length) {
        if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          return true;
        }
        else {
          return false;
        }
      }

    }
    catch (error) {

    }
  }
  mobile_number_length = 10;
  min_value;
  max_value;
  mobileLength(e) {
    try {
      if (e && this.master['isd'] && this.master['isd'].length) {
        for (let i = 0; i < this.master['isd'].length; i++) {
          if (e == this.master['isd'][i].isd_code) {
            if (this.master['isd'][i].mobile_number_length) {
              this.mobile_number_length = this.master['isd'][i].mobile_number_length;
            }
          }
        }
        this.min_value = '1';
        this.max_value = '9';
        for (let i = 0; i < this.mobile_number_length - 1; i++) {
          this.min_value = this.min_value + '0';
        }
        for (let i = 0; i < this.mobile_number_length - 1; i++) {
          this.max_value = this.max_value + '9';
        }
        this.resume_referral.controls.mobile_no.setValidators([Validators.required, Validators.min(parseInt(this.min_value)), Validators.max(parseInt(this.max_value))]);
      }
    }
    catch (error) {

    }
  }

  inputEmail(event: KeyboardEvent) {
    let input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;

    if (charCode === 20) {
      return false;
    }
    try {
      if (event.keyCode === 32) {
        return false;
      }
    }
    catch (error) {

    }
  }
  selected_obj(e) {
    try {
      if (e && e.isd_code) {
        this.mobileLength(e.isd_code);
      }
    }
    catch (e) {

    }
  }
}
